import { createSelector } from 'reselect';
import type { LocationState } from 'redux-first-router';
import { get } from 'lodash';
import {
  ROUTE_CREATE_CRITERIA,
  ROUTE_DISCOVER_INVESTING_IDEAS,
  ROUTE_DEPRECATED_PORTFOLIO_HOME,
  ROUTE_STOCKS_HOME,
  ROUTE_DEPRECATED_USER_PORTFOLIOS,
  ROUTE_DASHBOARD,
  ROUTE_WATCHLIST,
  ROUTE_MARKET,
} from '@/constants/routes';

const getLocation = ({ location }: { location: LocationState }) => ({
  type: get(location, ['type'], ''),
  prevType: get(location, ['prev', 'type'], ''),
  payload: get(location, ['payload'], undefined),
  query: get(location, ['query'], undefined),
});

export const getCanGoBack = createSelector(
  [getLocation],
  ({ type, prevType, payload }) => {
    const market = get(payload, ['market'], undefined);
    const stocksHome = type === ROUTE_STOCKS_HOME && market === undefined;
    return (
      RUNTIME_ENV === 'native' &&
      prevType !== '' &&
      stocksHome === false &&
      type !== ROUTE_DEPRECATED_USER_PORTFOLIOS &&
      type !== ROUTE_DASHBOARD &&
      type !== ROUTE_DEPRECATED_PORTFOLIO_HOME &&
      type !== ROUTE_DISCOVER_INVESTING_IDEAS &&
      type !== ROUTE_CREATE_CRITERIA &&
      type !== ROUTE_WATCHLIST &&
      type !== ROUTE_MARKET
    );
  }
);
